import { useState } from 'react'
import { getLanguages, getLanguageName, getCurrentLanguage } from '../../assets/js/functions'

export default function LangButton(props) {
    const [toggle, setToggle] = useState(true);

    function toggleHandler(event) {
       event.preventDefault();
       setToggle(!toggle);
    }

    return (
        <div className="tools_lang is-relative">
            <button onClick={toggleHandler} type="button" aria-expanded={toggle?'false':'true'} aria-controls="lang" className="button button--icon button--idiomes">
                <abbr title={getLanguageName(getCurrentLanguage())}>{getCurrentLanguage()}</abbr>
            </button>
            <ul id="lang" aria-hidden={toggle?'true':'false'}>
                {getLanguages().filter(value => value !== getCurrentLanguage()).map(value =>
                    <li key={value} className="mt-0">
                    <a hrefLang={value} lang={value} href={'/cuidar/'+value+'/home'} className="button w-100">
                        <abbr title={getLanguageName(value)}>{value}</abbr>
                    </a>
                </li>
                )}

            </ul>
        </div>
    )
}
